import { loggedIn } from '../../../../routes/conditional';
import paths from '../../../../routes/paths';
import { clearNewOrderFlow } from '../../../../redux/modules/neworder';
import { getPendingOrdersFromHomeReorder } from '../../../../redux/modules/root-reducer';

// eslint-disable-next-line import/prefer-default-export
export const page = {
  path: paths.createOrder.root,
  isAllowed: [loggedIn],
  action: ({ state }) => clearNewOrderFlow(getPendingOrdersFromHomeReorder(state)),
};
